type AdminEnv = {
  ADMIN_URL_PREFIX?: string;
  VITE_ADMIN_URL_PREFIX?: string;
};

const getImportMetaEnv = (): AdminEnv => {
  if (typeof import.meta === 'undefined') {
    return {};
  }
  const env = (import.meta as unknown as { env?: AdminEnv }).env;
  return env ?? {};
};

const getProcessEnv = (): AdminEnv => {
  if (typeof process === 'undefined' || !process.env) {
    return {};
  }
  return process.env as AdminEnv;
};

const readAdminPrefix = (): string => {
  const importMetaEnv = getImportMetaEnv();
  const processEnv = getProcessEnv();

  const rawPrefix =
    importMetaEnv.VITE_ADMIN_URL_PREFIX ??
    importMetaEnv.ADMIN_URL_PREFIX ??
    processEnv.VITE_ADMIN_URL_PREFIX ??
    processEnv.ADMIN_URL_PREFIX ??
    '';

  if (typeof rawPrefix !== 'string') {
    return '';
  }

  return rawPrefix.trim().replace(/^\/+|\/+$/g, '');
};

const adminUrlPrefix = readAdminPrefix();

export const adminBasePath = adminUrlPrefix ? `/${adminUrlPrefix}/admin` : '/admin';

export const adminPath = (path?: string): string => {
  if (!path) return adminBasePath;
  const sanitized = path.replace(/^\/+/, '');
  return `${adminBasePath}/${sanitized}`;
};

export const adminLoginPath = adminPath('login');

export const isAdminPath = (pathname: string): boolean => {
  if (!pathname) return false;
  return pathname === adminBasePath || pathname === adminLoginPath || pathname.startsWith(`${adminBasePath}/`);
};
